import React from 'react';
import NewVoiceCloningContainer from '@src/containers/NewVoiceCloning';

const VoiceCloning = () => <NewVoiceCloningContainer />;

export default VoiceCloning;
